export enum VendorsRouteNames {
  VENDORS_ROOT = 'VendorsRoot',
  VENDORS_LIST = 'VendorsRoot/Vendors',
  VENDORS_UPDATE = 'VendorsRoot/Vendors/Update',
}
